<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page>
    <f7-navbar title="訂單詳細資料" back-link="Back" />

    <div v-if="order" style="display: flex; flex-direction: column; height: 100%;">
      <div style="flex: 1; overflow: auto; height: 100%;">
        <f7-block-title :style="smallSizeStyle">餐點內容</f7-block-title>
        <f7-card>
          <f7-card-content :padding="false">
            <f7-list v-for="(reducedItemObj, index) in _items" :key="`order-details-reducedItemObj-${index}`" accordion-list>
              <f7-list-item :title="reducedItemObj.item.title" accordion-item :accordion-item-opened="true" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">
                  ${{ parseFloat(reducedItemObj.item.price) }}
                  <template v-if="reducedItemObj.amount >1">x {{ reducedItemObj.amount }}</template>
                </span>
                <f7-accordion-content>
                  <f7-list id="item-details" media-list style="padding-left: 10px;">
                    <f7-list-item
                      v-for="(detail, index) in itemPriceDetails(reducedItemObj.item)"
                      :key="`order-details-detail-${index}`"
                      :title="detail.valueStringWithTitle"
                      :style="normalSizeStyle"
                      style="padding: 0px;">
                      <span v-if="detail.totalPrice !== 0" slot="after" :style="smallSizeStyle">${{ detail.currentLevelPrice }}</span>
                    </f7-list-item>
                    <f7-list-item v-if="reducedItemObj.item.stateObj.specialRequests" title="備註:" :style="normalSizeStyle">
                      <span slot="after" :style="smallSizeStyle">{{ reducedItemObj.item.stateObj.specialRequests }}</span>
                    </f7-list-item>
                  </f7-list>
                </f7-accordion-content>
              </f7-list-item>
            </f7-list>
          </f7-card-content>
        </f7-card>

        <f7-block-title :style="smallSizeStyle">付款/發票/收據</f7-block-title>
        <f7-card>
          <f7-card-content :padding="false">
            <!-- <div style="display: flex; justify-content: center;">
              <barcode :text="'A003-' + parseInt(order.totalPrice)" />
            </div> -->
            <f7-list>
              <f7-list-item title="付款方式:" :style="normalSizeStyle">
                <div slot="after" :style="smallSizeStyle">
                  <img v-if="order.paymentMethod === paymentMethodType.easyCard" src="@/assets/easyCard.png" :style="afterImageStyle" />
                  <img v-else-if="order.paymentMethod === paymentMethodType.creditCard" src="@/assets/creditCard.png" :style="afterImageStyle" />
                  <img v-else-if="order.paymentMethod === paymentMethodType.linePayOnline" src="@/assets/linePay.png" :style="afterImageStyle" />
                  <img v-else-if="order.paymentMethod === paymentMethodType.chinaUnionPay" src="@/assets/chinaUnionPay.png" :style="afterImageStyle" />
                  <img v-else-if="order.paymentMethod === paymentMethodType.jkos" src="@/assets/jkos.png" :style="afterImageStyle" />
                  <img v-else-if="order.paymentMethod === paymentMethodType.cash" src="@/assets/cash.png" :style="afterImageStyle" />
                  {{ $t(`paymentMethodType.${order.paymentMethod}`) }}
                </div>
              </f7-list-item>
              <f7-list-item v-if="order.serviceCharge" :title="`服務費(${order.serviceCharge}%):`" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ serviceFee(order.serviceCharge, order.originalPrice) }} 元</span>
              </f7-list-item>
              <f7-list-item v-if="order.discount && Object.keys(order.discount).length > 0 && order.discount.val > 0" :title="`優惠折扣(${order.discount.val}%):`" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ parseFloat(order.originalPrice) - parseFloat(order.totalPrice) }} 元</span>
              </f7-list-item>
              <f7-list-item v-if="order.invoiceNumber" title="發票號碼:" :style="normalSizeStyle">
                <span v-if="hasPermissions(permissionType.updateOrderReceiptPrintedStatus)" slot="after-title">
                  <f7-button raised fill @click="uploadEInvoice" style="margin: 0px 10px;">重新上傳</f7-button>
                </span>
                <span slot="after" :style="smallSizeStyle">{{ order.invoiceNumber }}</span>
              </f7-list-item>
              <f7-list-item v-if="order.useReceipt && order.useCashier && order.menuReceiptSetting && order.menuReceiptSetting.useReceipt" title="發票載具 / 捐贈:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ $t(`receiptCarrierType.${order.receiptCarrier}`) }}</span>
              </f7-list-item>
              <f7-list-item v-if="order.receiptCarrier === receiptCarrierType.donate && order.receiptCarrierId" title="愛心碼:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.receiptCarrierId }}</span>
              </f7-list-item>
              <f7-list-item v-else-if="order.receiptCarrierId" title="載具 ID:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.receiptCarrierId }}</span>
              </f7-list-item>
              <f7-list-item v-if="!(order.useCashier && order.useReceipt && order.receiptCarrier !== receiptCarrierType.paper) && order.taxId" title="統一編號:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.taxId }}</span>
              </f7-list-item>
              <f7-list-item v-if="order.invoiceTitle" title="收據抬頭:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.invoiceTitle }}</span>
              </f7-list-item>
            </f7-list>
          </f7-card-content>
        </f7-card>

        <f7-block-title :style="smallSizeStyle">基本資料</f7-block-title>
        <f7-card>
          <f7-card-content :padding="false">
            <f7-list>
              <f7-list-item title="訂單代號:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.nickname }}</span>
              </f7-list-item>
              <f7-list-item title="用餐方式:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ $t(`diningPreferenceType.${order.diningPreference}`) }}</span>
              </f7-list-item>
              <f7-list-item v-if="order.diningPreference === diningPreferenceType.forHere" title="桌號:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.tableNumber }}</span>
              </f7-list-item>
              <template v-else-if="order.diningPreference === diningPreferenceType.preOrder">
                <f7-list-item title="手機號碼:" :style="normalSizeStyle">
                  <span slot="after" :style="smallSizeStyle">{{ order.phoneNumber }}</span>
                </f7-list-item>
                <f7-list-item title="取餐時間:" :style="normalSizeStyle">
                  <span slot="after" :style="smallSizeStyle">{{ moment(order.pickupTime).format('MM/DD HH:mm') }}</span>
                </f7-list-item>
              </template>
              <f7-list-item title="總價:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ parseFloat(order.totalPrice) }} 元 {{ order.refundedAt ? '(已退款)' : '' }}</span>
              </f7-list-item>
            </f7-list>
          </f7-card-content>
        </f7-card>

        <f7-block-title :style="smallSizeStyle">更改記錄</f7-block-title>
        <f7-card>
          <f7-card-content :padding="false">
            <f7-list>
              <f7-list-item title="收到訂單:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.receivedAt ? moment(order.receivedAt).format('YYYY/MM/DD HH:mm') : '無資料' }}</span>
              </f7-list-item>
              <f7-list-item title="列印訂單:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.printedAt ? moment(order.printedAt).format('YYYY/MM/DD HH:mm') : '無資料' }}</span>
              </f7-list-item>
              <f7-list-item title="付款:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.paidAt ? moment(order.paidAt).format('YYYY/MM/DD HH:mm') : '無資料' }}</span>
              </f7-list-item>
              <f7-list-item title="開始製作:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.startPreparingAt ? moment(order.startPreparingAt).format('YYYY/MM/DD HH:mm') : '無資料' }}</span>
              </f7-list-item>
              <f7-list-item title="完成餐點:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.doneAt ? moment(order.doneAt).format('YYYY/MM/DD HH:mm') : '無資料' }}</span>
              </f7-list-item>
              <f7-list-item title="客人取餐:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ order.deliveredAt ? moment(order.deliveredAt).format('YYYY/MM/DD HH:mm') : '無資料' }}</span>
              </f7-list-item>
              <f7-list-item v-if="order.refundedAt" title="退款:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ moment(order.refundedAt).format('YYYY/MM/DD HH:mm') }}</span>
              </f7-list-item>
              <f7-list-item title="最後更新時間:" :style="normalSizeStyle">
                <span slot="after" :style="smallSizeStyle">{{ moment(order.updatedAt).format('YYYY/MM/DD HH:mm') }}</span>
              </f7-list-item>
            </f7-list>
          </f7-card-content>
        </f7-card>

        <f7-block-title :style="smallSizeStyle">訂單 QR code</f7-block-title>
        <f7-card>
          <f7-card-content :padding="true" style="display: flex; justify-content: center;">
            <qr-code v-if="order" :text="order.publicId" :size="qrCodeWidth" level="H" />
          </f7-card-content>
        </f7-card>
      </div>

      <f7-list v-if="!order.paidAt || order.printedAt || (!order.refundedAt && hasPermissions(permissionType.refundOrder))" style="margin: 0px; flex: 0;" :style="normalSizeStyle">
        <f7-list-item v-if="!order.paidAt">
          <f7-button raised fill @click="pay" v-if="isShowCheckoutButton" style="width: 100%;" :style="normalButtonSizeStyle">結帳完成 (${{ parseFloat(order.totalPrice) }})</f7-button>
        </f7-list-item>
        <f7-list-item v-else>
          <f7-list-item-cell v-if="order.printedAt && hasPermissions(permissionType.updateOrderReceiptPrintedStatus)">
            <f7-button raised fill @click="updatePrintStatus(false)" :style="normalButtonSizeStyle">重新列印</f7-button>
          </f7-list-item-cell>
          <f7-list-item-cell v-if="!order.refundedAt && hasPermissions(permissionType.refundOrder)">
            <f7-button raised fill @click="refundOnClick" :style="normalButtonSizeStyle">
              {{ $t(`paymentMethodType.${order.paymentMethod}`) }} 退款 (${{ parseFloat(order.totalPrice) }})
            </f7-button>
          </f7-list-item-cell>
        </f7-list-item>
      </f7-list>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Radio } from '@/common/model/questions/Radio'
import QrCode from '@/common/components/QrCode'
import moment from 'moment'
import { storeClient } from '@/service/apiClients'
import Vue from 'vue'
import { Decimal } from 'decimal.js'
import Barcode from '@/components/Barcode'

export default {
  dependencies: [
    'paymentMethodType',
    'CartElementBuilder',
    'receiptCarrierType',
    'diningPreferenceType',
    'permissionType'
  ],
  data () {
    return {
      windowWidth: 0,
      orderPublicId: this.orderPublicIdProp,
      storeData: null,
      isShowCheckoutButton: false
    }
  },
  watch: {
    order (v) {
      if (!v) {
        this.$f7router.back()
        // this.$f7.notification.create({
        //   title: '麥子磨麵',
        //   titleRightText: '中興店',
        //   text: '訂單已更新',
        //   closeOnClick: true,
        //   closeButton: true,
        //   closeTimeout: 2000
        // }).open()
      }
    }
  },
  computed: {
    ...mapState(['settings']),
    ...mapState('orderModule', ['channels']),
    ...mapState('menuModule', ['menus']),
    ...mapState('userModule', ['uid', 'permissions']),
    moment () { return moment },
    menu () {
      return this.menus[this.order.menuVariation] ? this.menus[this.order.menuVariation][this.order.menuVersion] : null
    },
    order () {
      return this.channels.main.orderList.find(order => order.publicId === this.orderPublicId) ||
        this.channels.secondary.orderList.find(order => order.publicId === this.orderPublicId)
    },
    items () {
      return this.order.data.items.map(itemObj => this.CartElementBuilder.buildItem(itemObj, this.menu))
    },
    _items () {
      return this.order.data.items.map(itemObj =>
        this.CartElementBuilder.buildItem(itemObj, this.menu)
      ).reduce((items, item) => {
        const target = items.find(i => i.item.price === i.item.totalPrice && i.item.equalsToItem(item))
        if (!target) {
          return items.concat([{
            amount: 1,
            item: item
          }])
        }
        target.amount = target.amount ? target.amount + 1 : 1
        return items
      }, [])
    },
    serviceFee () {
      return (serviceCharge, originalPrice) => {
        // 計算 原價 / (1 + 服務費(%))
        let temp = new Decimal(originalPrice).dividedBy(new Decimal(serviceCharge).dividedBy(100).plus(1)).toFixed(0)
        return originalPrice - temp
      }
    },
    qrCodeWidth () {
      return Math.min(300, this.windowWidth * 0.5)
    },
    normalSizeStyle () {
      return { 'font-size': `${this.settings.fontSize}px`, 'line-height': `${this.settings.fontSize * 3 / 2}px` }
    },
    smallSizeStyle () {
      return { 'font-size': `${this.settings.fontSize * 7 / 8}px`, 'line-height': `${(this.settings.fontSize * 7 / 8) * 3 / 2}px` }
    },
    afterImageStyle () {
      return { 'height': `${this.settings.fontSize * 7 / 8 - 2}px` }
    },
    normalButtonSizeStyle () {
      return {
        'font-size': `${this.settings.fontSize - 2}px`,
        'line-height': `${this.settings.fontSize + 20}px`,
        'height': `${this.settings.fontSize + 20}px`
      }
    }
  },
  props: {
    storeIdProp: String,
    orderPublicIdProp: String
  },
  created () {
    this.setStore(this.storeIdProp)
  },
  async mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      // Init
      this.getWindowWidth()
    })
    // 因為要比較現金和其他付款方式折扣的差異，一開始要先取得 storeData
    const { data: storeData } = await storeClient.get(`/stores/${this.storeIdProp}`)
    Vue.set(this, 'storeData', Object.assign({}, storeData))

    this.checkIsOrderCashPayment() // 檢查是否不是現金付款，而且該付款價格跟現金付款不一致，則顯示提醒視窗
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('orderModule', ['setOrderPaid']),
    ...mapActions('orderModule', ['updateOrder']),
    hasPermissions (permissions) {
      if (typeof permissions === 'string') {
        return (!!this.permissions[this.storeIdProp] && this.permissions[this.storeIdProp][permissions]) || (!!this.permissions['*'] && this.permissions['*'][permissions])
      } else if (permissions instanceof Array) {
        //
      }
      return false
    },
    pay () {
      this.setOrderPaid({ order: this.order, channel: 'main' })
      this.$f7router.back()
    },
    itemPriceDetails (item) {
      const questions = item.allLevelQuestions
      const details = item.questions ? questions.filter(q => q.alwaysDisplay || !q.isValueDefault || q instanceof Radio) : []
      return details.filter(d => d)
    },
    updatePrintStatus (printedAt) {
      storeClient.put(`/stores/${this.storeIdProp}/orders/${this.orderPublicIdProp}/printStatus`, { printedAt })
    },
    refundOnClick () {
      this.$f7.dialog.confirm('是否將這筆訂單退款', this.$t(`paymentMethodType.${this.order.paymentMethod}`) + '退款', () => {
        if (this.order.paymentMethod === this.paymentMethodType.linePayOnline || this.order.paymentMethod === this.paymentMethodType.cash) {
          this.orderRefund()
        } else {
          this.$f7router.navigate(`/stores/${this.storeIdProp}/orders/${this.order.publicId}/refund`)
        }
      })
    },
    checkIsOrderCashPayment () {
      if (!this.order.paidAt && this.order.paymentMethod !== this.paymentMethodType.cash) {
        const cashDiscountRatio = new Decimal(100).minus(this.storeData.payDiscount.acceptCash || 0).dividedBy(100)
        const cashDiscountTotal = Number(cashDiscountRatio.times(this.order.originalPrice).toFixed(0))
        const vm = this
        if (parseFloat(this.order.totalPrice) !== parseFloat(cashDiscountTotal)) {
          return this.$f7.dialog.create({
            title: '是否改為現金付款',
            text: `付款金額 $${parseFloat(this.order.totalPrice)} -> $${cashDiscountTotal}`,
            buttons: [
              {
                text: '否'
              },
              {
                text: '是'
              }
            ],
            onClick (dialog, index) {
              if (index === 1) {
                vm.isShowCheckoutButton = true
                // 更新訂單 : totalPrice 改為現金折扣的價格和 discount 改為現金折扣百分比，付款方式改為現金
                const newOrder = { ...vm.order }
                const cashDiscount = {
                  type: 'percent',
                  val: vm.storeData.payDiscount.acceptCash || 0
                }
                const totalPrice = cashDiscountTotal
                newOrder.discount = cashDiscount
                newOrder.totalPrice = totalPrice.toString()
                newOrder.paymentMethod = vm.paymentMethodType.cash
                vm.updateOrder({ order: newOrder })
              }
            }
          }).open()
        }
      }
      this.isShowCheckoutButton = true
    },
    async orderRefund () {
      const order = Object.assign({}, this.order)
      try {
        this.$f7.dialog.progress('正在進行退款，請稍待...')
        await storeClient.put(`/stores/${this.storeIdProp}/orders/${this.orderPublicIdProp}/payment/${order.paymentMethod}/refund`)
        this.$utils.nextFrame(() => this.$f7.dialog.close())
        this.$f7router.back()
        this.$f7.notification.create({
          title: order.nickname,
          titleRightText: this.$t(`paymentMethodType.${order.paymentMethod}`),
          text: '退款成功',
          closeOnClick: true,
          closeButton: true,
          closeTimeout: 2000
        }).open()
      } catch (e) {
        this.$utils.nextFrame(() => this.$f7.dialog.close())
        this.$f7.notification.create({
          title: order.nickname,
          titleRightText: this.$t(`paymentMethodType.${order.paymentMethod}`),
          text: '退款失敗',
          closeOnClick: true,
          closeButton: true,
          closeTimeout: 2000
        }).open()
      }
    },
    async uploadEInvoice () {
      await storeClient.get(`/orders/${this.order.publicId}/uploadEInvoice`)
    },
    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth
    }
  },
  components: {
    QrCode,
    Barcode
  }
}
</script>

<style scoped>
</style>

<style lang="scss">
#item-details {
  .item-inner {
    padding: 5px 42px 5px 0px;
  }
}
</style>
